import RightArrowIcon from '@/assets/RightArrowIcon';
import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import LencoButton from '@/atomic-components/LencoButton';
import { useLocation } from '@/hooks/useLocation';
import { RentalRouteHelper } from '@/utils/routes';
import { getColor } from '@/utils/theme/colors';
import { getStyle } from '@/utils/theme/fonts';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { Box } from '@mui/system';
import { useRouter } from 'next/router';

const Arrow = () => {
	return (
		<svg
			width='12'
			height='12'
			viewBox='0 0 12 12'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M2.5 6H9.5'
				stroke='white'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				d='M6 2.5L9.5 6L6 9.5'
				stroke='white'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
};

function BuyRentSelector() {
	const { selectedLocation } = useLocation();
	const router = useRouter();

	function rentTapped() {
		router.push(
			RentalRouteHelper({ cityId: selectedLocation.cityId as number })
		);
	}

	function buyTapped() {
		router.push('/buy');
	}

	return (
		<FlexBox
			fullWidth
			sx={{ borderRadius: '32px', overflow: 'hidden' }}
			id='buy_rent-wrapper'
		>
			<LencoButton
				fullWidth
				sx={{
					padding: '16px 40px',
					borderRadius: '0px',
					backgroundColor: getColor('Navy -1'),
					':hover': {
						backgroundColor: getColor('Navy 0'),
					},
				}}
				id='buy_rent-buy'
				onClick={buyTapped}
			>
				<FlexBox
					fullWidth
					alignItems={'center'}
					justifyContent={'space-between'}
				>
					<Box sx={{ transform: 'rotate(180deg)' }}>
						<RightArrowIcon />
					</Box>
					<LencoTypography color='white' sx={getStyle('H11A_Medium')}>
						Explore Buying
					</LencoTypography>
				</FlexBox>
			</LencoButton>
			<LencoButton
				fullWidth
				sx={{
					padding: '16px 40px',
					borderRadius: '0px',
					backgroundColor: getColor('Orange -1'),
					':hover': {
						backgroundColor: getColor('Orange 0'),
					},
				}}
				id='buy_rent-rent'
				onClick={rentTapped}
			>
				<FlexBox
					fullWidth
					alignItems={'center'}
					justifyContent={'space-between'}
				>
					<LencoTypography color='white' sx={getStyle('H11A_Medium')}>
						Explore Renting
					</LencoTypography>
					<RightArrowIcon />
				</FlexBox>
			</LencoButton>
		</FlexBox>
	);
}

export default BuyRentSelector;
